import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <section className="section about-us" id="about">
      <div className="container">
        <div className="about-content">
          <div className="about-image">
            <img 
              src="https://i.pinimg.com/736x/f4/d2/dc/f4d2dcf2227ade576ccf8955631db470.jpg" 
              alt="Travel Experience" 
            />
          </div>
          
          <div className="about-text">
            <div className="section-subtitle">ABOUT US</div>
            <h2 className="section-heading">Welcome to Ghoomo India</h2>
            <p className="about-description">
              Ghoomo India is your trusted travel partner, dedicated to creating unforgettable travel experiences across the incredible landscapes of India and beyond. With years of expertise in the travel industry, we specialize in crafting personalized journeys that combine adventure, culture, and comfort.
            </p>
            <p className="about-description">
              Our team of travel experts works tirelessly to ensure every trip is perfectly tailored to your preferences, from luxury accommodations to authentic local experiences. We believe that travel should be more than just visiting places – it should be about creating memories that last a lifetime.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;
